module.exports = __webpack_public_path__ + "8c03ce991e3a8986916bc240adf13227.svg";